import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Mail, Send, ShieldCheck } from "lucide-react";

export default function Support() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [mine, setMine] = useState([]);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/support/mine"); setMine(data); } catch (e) {}
  }, []);

  useEffect(() => { load(); }, [load]);

  const send = async () => {
    if (!text.trim()) { toast.error("Write a message first"); return; }
    setBusy(true);
    try {
      await api.post("/support", { text });
      toast.success("Message sent to the House team");
      setText(""); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    setBusy(false);
  };

  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 py-10">
      <div className="flex items-center gap-3 mb-2">
        <Mail className="text-[#B8860B]" size={28} strokeWidth={2.5} />
        <h1 className="font-display font-black text-4xl tracking-tighter">Contact the House</h1>
      </div>
      <p className="text-black/50 font-medium mb-8">Questions, disputes, or report a rule-breaking listing? Message the Tradeable Exchange team directly.</p>

      <div className="bg-white nb-border rounded-2xl p-6 nb-shadow">
        <textarea data-testid="support-text" value={text} onChange={(e) => setText(e.target.value)} rows={5}
          placeholder="Type your message to the House…" className="w-full p-3 nb-border rounded-xl font-medium outline-none focus:ring-2 focus:ring-[#E6B31E]" />
        <button data-testid="support-send-btn" disabled={busy} onClick={send}
          className="w-full mt-3 flex items-center justify-center gap-2 bg-black text-[#E6B31E] font-extrabold rounded-full py-3.5 disabled:opacity-50">
          <Send size={18} strokeWidth={2.5} /> {busy ? "Sending…" : "Send message"}
        </button>
      </div>

      {mine.length > 0 && (
        <>
          <h2 className="font-display font-extrabold text-xl mt-10 mb-4">Your messages</h2>
          <div className="space-y-3">
            {mine.map((m) => (
              <div key={m.id} data-testid={`my-msg-${m.id}`} className="bg-white nb-border rounded-2xl p-4 nb-shadow">
                <p className="font-medium text-sm">{m.text}</p>
                <div className="flex items-center gap-1.5 text-[11px] font-bold mt-2 text-black/40">
                  {m.read ? <><ShieldCheck size={13} className="text-green-600" strokeWidth={3} /> Seen by the House</> : "Sent · awaiting review"}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
